/* eslint-disable react/prop-types */
import React from 'react'
import { Navigate } from 'react-router-dom'
import { hasSessionHint } from '../../services/authTokens'
import { ADMIN_AUTH_STATUS, isAllowedAdminRole } from '../../common/adminAuth'

function Protected({ authStatus, user, children }) {
  const hasAuthSession = hasSessionHint()
  const isBootstrapping =
    authStatus === ADMIN_AUTH_STATUS.CHECKING ||
    (authStatus === ADMIN_AUTH_STATUS.IDLE && hasAuthSession)

  if (isBootstrapping) {
    return (
      <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
      </div>
    )
  }

  if (authStatus !== ADMIN_AUTH_STATUS.AUTHENTICATED) {
    return <Navigate to="/login" replace />
  }

  if (!isAllowedAdminRole(user?.role)) {
    return <Navigate to="/login" replace />
  }

  return children
}
export default Protected
